import React from "react";
import PersonalWork from "./overview/PersonalWork";

// The homepage shows the Personal Work gallery — same images and behaviour
// as /overview/personal-work, kept as a single source of truth.
const Home = () => {
  return <PersonalWork />;
};

export default Home;
